module.exports = __webpack_public_path__ + "img/hr-steam-turbine-H-shadow.c08261d7.png";